import React from 'react'
function PastEvents() {
    return (
        <div>
            <h1>Past Events</h1>
        </div>
    )
}

export default PastEvents
